import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { DateType } from '../interfaces/common.interface';
import { defaultLocale } from '../constants';

export interface LuxonHelpersDateRangeData {
  dateFrom: string;
  dateTo: string;
  dateFromInputTimeZone: string;
  dateFromTargetTimeZone: string;
  dateToInputTimeZone: string;
  dateToTargetTimeZone: string;
}

@Injectable({
  providedIn: 'root',
})
export class LuxonHelpersService {
  checkIfSameDay(data: LuxonHelpersDateRangeData): boolean {
    const { dateOne, dateTwo } = this._getDates(data);
    return dateOne.hasSame(dateTwo, 'day');
  }

  checkIfSameTimezone(data: LuxonHelpersDateRangeData): boolean {
    const { dateOne, dateTwo } = this._getDates(data);
    return dateOne.offset - dateTwo.offset === 0;
  }

  setDateTimeZone(date: DateTime, timezone: string): DateTime {
    return date.setZone(timezone);
  }

  getLuxonDate(
    date: string,
    timezone = 'local',
    dateType = DateType.SQL
  ): DateTime {
    switch (dateType) {
      case DateType.SQL:
        return DateTime.fromSQL(date, {
          locale: defaultLocale,
          zone: timezone,
        });
      case DateType.ISO:
        return DateTime.fromISO(date, {
          locale: defaultLocale,
          zone: timezone,
        });
    }
  }

  private _getDates(data: LuxonHelpersDateRangeData) {
    const dateFrom = this.getLuxonDate(
      data.dateFrom,
      data.dateFromInputTimeZone
    );
    const dateTo = this.getLuxonDate(data.dateTo, data.dateToInputTimeZone);

    return {
      dateOne: this.setDateTimeZone(dateFrom, data.dateFromTargetTimeZone),
      dateTwo: this.setDateTimeZone(dateTo, data.dateFromTargetTimeZone),
    };
  }
}
